import React, { useContext, useEffect } from 'react'
import Repl from '../Components/Repl'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import PrevDataContext from '../Context/PrevDataContext';
export default function Repls() {
    const navigator = useNavigate()
    const {files,getFiles} = useContext(PrevDataContext)

    useEffect(()=>{
        if(!localStorage.getItem("authtoken")){
            toast.error("Please Login first");
            navigator("/")
        }else{
            getFiles()
        }
        // eslint-disable-next-line 
    },[])
    function handleOnClick() {
        navigator("/create-room")
    }

    return (
        <div className='repls'>
            <div className="top">
                <h1>Hey {localStorage.getItem("username")}</h1>
            </div>
            <div className="bottom">
                Create a New file
                <div className="new-file" onClick={handleOnClick}>
                <i className="fa-solid fa-3x fa-plus"></i>
                </div>
            </div>
            <div className="repls-container">
                <div className="repls-container-top">
                    <p>Recent Programs</p>
                </div>
                <div className="repls-container-bottom">
                    {
                        files.map(file=>{
                            return <Repl key={file
                            ._id} roomId={file.roomId} filename={file.filename} time={file.updatedAt} username={file.username} language={file.language} />
                        })
                    }
                </div>
                
            </div>
        </div>
    )
}
